import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import BaseLayout from 'base/layouts/Layout';

const MenuLayout = ({ children, heroImageSrc, heroImageAlt, isFetching }) => (
  <BaseLayout
    heroSrc={heroImageSrc}
    heroAlt={heroImageAlt}
    isFetching={isFetching}
  >
    {children}
  </BaseLayout>
);

MenuLayout.propTypes = {
  children: PropTypes.object,
  heroImageSrc: PropTypes.string,
  heroImageAlt: PropTypes.string,
  isFetching: PropTypes.bool
};

const mapStateToProps = state => {
  const image = get(state.menu, 'images[0]', {});
  return {
    isFetching: state.menu.isFetching,
    heroImageSrc: image.url,
    heroImageAlt: image.alt_text
  };
};

export default connect(mapStateToProps)(MenuLayout);
